/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { schemaState } from "./schema.state";

const schema = createSlice({
    name: "schemas",

    initialState: schemaState,

    reducers: {
        addSchemas (state, action) {
            const schemas = action.payload;
            state.all = schemas;
        },
    },
});

export const schemaReducer = schema.reducer;

export const { addSchemas } = schema.actions;

